import React,{useEffect,useState} from 'react';
import { useLocation } from 'react-router-dom';

function ShowNavbar({children}) {
  const location = useLocation();
  const [showNavbar,setShowNavbar] = useState(false)


  useEffect(()=>{   
    if(location.pathname === '/Login' 
    || location.pathname === '/mfa' 
    || location.pathname === '/support' 
    ||  location.pathname === '/worldcollection' 
    || location.pathname === '/payment' 
    || location.pathname === '/Signup' 
    || location.pathname === '/PasswordReset' 
    || location.pathname === '/SelectPlan' 
    || location.pathname === '/AccountDetails' 
    || location.pathname === '/ArtistDetails' 
    || location.pathname === '/Dashboard' 
    || location.pathname === '/Dashboard/releasemusic'  
    || location.pathname === '/Dashboard/releasemusic/uploadtracks' 
    || location.pathname === '/Dashboard/releasemusic/uploadphoto' 
    || location.pathname === '/Dashboard/releasemusic/albumdetails'
    || location.pathname === '/Dashboard/releasemusic/trackdetails'
    || location.pathname === '/Dashboard/releasemusic/royaltysplit' 
    || location.pathname === '/Dashboard/releasemusic/releasedate' 
    || location.pathname === '/Dashboard/releasemusic/albumsummary' 
    || location.pathname === '/Dashboard/music' 
    || location.pathname === '/Dashboard/music/albumdetails' 
    || location.pathname === '/Dashboard/music/trackdetails' 
    || location.pathname === '/Dashboard/analytics' 
    || location.pathname === '/Dashboard/money' 
    || location.pathname === '/Dashboard/money/' 
    || location.pathname === '/Dashboard/money/wallet' 
    || location.pathname === '/Dashboard/money/statements' 
    || location.pathname === '/Dashboard/exclusives' 
    || location.pathname === '/Dashboard/promoteyourself' 
    || location.pathname === '/Dashboard/promoteyourself/verifiedartist' 
    || location.pathname === '/Dashboard/promoteyourself/lyricvideo' 
    || location.pathname === '/Dashboard/promoteyourself/youtubemonetize' 
    || location.pathname === '/Dashboard/promoteyourself/worldcollection' 
    || location.pathname === '/Dashboard/settings' 
    || location.pathname === '/Dashboard/settings/artistname' 
    || location.pathname === '/Dashboard/settings/changeplan' 
    || location.pathname === '/Dashboard/settings/accsettings' 
    || location.pathname === '/Dashboard/settings/secsettings' 
    || location.pathname === '/Dashboard/settings/walletsettings' 
    || location.pathname === '/Dashboard/settings/notifsettings'
    || location.pathname === '/Dashboard/settings/deletesettings'
    || location.pathname === '/dashboard/label' 
    || location.pathname === '/dashboard/label/releasemusic' 
    || location.pathname === '/dashboard/label/releasemusic/uploadtracks'
    || location.pathname === '/dashboard/label/releasemusic/uploadphoto'
    || location.pathname === '/dashboard/label/releasemusic/albumdetails'
    || location.pathname === '/dashboard/label/releasemusic/trackdetails'
    || location.pathname === '/dashboard/label/releasemusic/royaltysplit'
    || location.pathname === '/dashboard/label/releasemusic/releasedate'
    || location.pathname === '/dashboard/label/releasemusic/albumsummary'
    || location.pathname === '/dashboard/label/catalog' 
    || location.pathname === '/dashboard/label/catalog/assets' 
    || location.pathname === '/dashboard/label/catalog/artists' 
    || location.pathname === '/dashboard/label/catalog/people' 
    || location.pathname === '/dashboard/label/catalog/publishers' 
    || location.pathname === '/dashboard/label/catalog/labels' 
    || location.pathname === '/dashboard/label/roster' 
    || location.pathname === '/dashboard/label/accounting' 
    || location.pathname === '/dashboard/label/accounting/' 
    || location.pathname === '/dashboard/label/accounting/wallet' 
    || location.pathname === '/dashboard/label/accounting/statements' 
    || location.pathname === '/dashboard/label/promoteartist' 
    || location.pathname === '/dashboard/label/promoteartist/verifiedartist' 
    || location.pathname === '/dashboard/label/promoteartist/lyricvideo' 
    || location.pathname === '/dashboard/label/promoteartist/youtubemonetize' 
    || location.pathname === '/dashboard/label/promoteartist/worldcollection' 
    || location.pathname === '/dashboard/label/exclusives' 
    || location.pathname === '/dashboard/label/settings'
    || location.pathname === '/dashboard/label/settings/'
    || location.pathname === '/dashboard/label/settings/accsettings'
    || location.pathname === '/dashboard/label/settings/secsettings'
    || location.pathname === '/dashboard/label/settings/walletsettings'
    || location.pathname === '/dashboard/label/settings/notifsettings'
    || location.pathname === '/dashboard/label/settings/changeplan'
    || location.pathname === '/dashboard/label/settings/artistname'
    || location.pathname === '/dashboard/label/settings/deletesettings'
    || location.pathname === '/dashboard/label/support'
    || location.pathname === '/help' 
    || location.pathname === '/help/info' 
    || location.pathname === '/help/form' 
    || location.pathname === '/verify/email'){
        setShowNavbar(false)
    }else{
        setShowNavbar(true)
    }
  },[location])

  return (
    <div>
        {showNavbar && children}
    </div>
  );
}

export default ShowNavbar;


